
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// reactstrap components
import { Form, FormGroup, Label, Button, Input, Modal, ModalHeader, ModalBody } from 'reactstrap';

import { Fragment } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useTranslate } from 'react-translate';
import AnalysisAsyncContacts from './AnalysisAsyncContacts';
import { actionSubmitAnalysis } from 'store/actions/analysisActions';
import { useHistory } from 'react-router';
import AnalysisInvitePatientForm from './AnalysisInvitePatientForm';
import { actionSetNewPatientData } from 'store/actions/analysisActions';

const AnalysisForm = ({ }) => {
  const t = useTranslate('analysis');
  const tTypes = useTranslate("study-type");
  const history = useHistory();
  const dispatch = useDispatch();
  const studyTypes = useSelector(state => state.analysisReducer.studyTypes);
  const practiceId = useSelector((state) => state.userAuthorizationReducer._id);
  const patientData = useSelector(state => state.analysisReducer.patientData);
  const isPatientDataNull = !Object.keys(patientData).length;

  const [analysisType, setAnalysisType] = useState("empty");
  const [inviteOpen, setInviteOpen] = useState(false);

  useEffect(() => {
    if (!isPatientDataNull) {
      setInviteOpen(false);
    }
  }, [patientData]);

  const modalToggle = () => {
    setInviteOpen(!inviteOpen);
  }

  useEffect(() => {
    return () => {
      dispatch(actionSetNewPatientData({}));
    }
  }, []);

  const defaultValues = {
    patient_email: "",
    doctor_email: "",
    device_id: ""
  };

  const { register, handleSubmit, control, errors } = useForm({
    defaultValues,
  });


  const onSubmit = (data) => {

    if (!data.doctor) {
      toast.error(t("error-doctor-not-selected"));
      return;
    }

    if (!data.patient && isPatientDataNull) {
      toast.error(t("error-patient-not-selected"));
      return;
    }

    if (analysisType === "empty") {
      toast.error(t("error-type-not-selected"));
      return;
    }

    dispatch(actionSubmitAnalysis({
      type: analysisType,
      doctor_email: data.doctor.value,
      patient_email: !isPatientDataNull ? patientData.email : data.patient.value,
      device_id: data.device,
      practice: practiceId
    }));
  };

  return (
    <Fragment>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <div className="d-flex" style={{gap: "15px"}}>
          <FormGroup style={{width: "50%"}}>
            <Label for="to">{t("study-type")}</Label>
            <Input 
              className={analysisType === "empty" ? `has-danger` : ""}
              type="select" 
              name="type" 
              id="type"
              ref={register}
              onChange={(e) => {
                setAnalysisType(e.target.value);
              }}
            >
              <option value="empty">-</option>
              {studyTypes.length && studyTypes.map(tp => {
                return <option value={tp}>{tTypes(tp.replace(" ", '-'))}</option>;
              })}
            </Input>
          </FormGroup>

          <FormGroup style={{width: "50%"}}>
            <Label for="to">{t("device-id")}</Label>
            <input
              className={`form-control ${errors.device ? "has-danger" : ""}`}
              type="text"
              name="device"
              id="device"
              ref={register({ required: true, maxLength: 255 })}
            />
            {errors.device && (
              <p className="alert alert-danger mt-2 w-50">{t("device-required")}</p>
            )}
          </FormGroup>
        </div>

        <FormGroup>
          <Label for="to">{t("doctor")}</Label>
          <AnalysisAsyncContacts
            name="doctor"
            register={register}
            control={control}
            focus
          />
        </FormGroup>

        <FormGroup >

          <div className="d-flex" style={{gap: "15px"}}>
            <div style={{width: "100%"}}>
              <Label for="to">{t("patient")}</Label>

              {!isPatientDataNull || inviteOpen
              ? <input
                  type="text"
                  className="form-control"
                  readOnly={true}
                  defaultValue={
                    !isPatientDataNull ? `${patientData.firstName} ${patientData.lastName} (${patientData.email})` : t("patient")
                  }
                  value={
                    !isPatientDataNull ? `${patientData.firstName} ${patientData.lastName} (${patientData.email})` : t("patient")
                  }
                />
              : <AnalysisAsyncContacts
                  name="patient"
                  register={register}
                  control={control}
                  focus
                />
              }
            </div>
            
            {!inviteOpen ? 
            <div style={{marginTop: "15px"}}>
              
                <Button
                  onClick={() => {
                    setInviteOpen(!inviteOpen);
                  }}
                >
                  {t("invite-user")}
                </Button>
            </div> : (<></>)
            }
          </div>
          
        </FormGroup>

        <Modal isOpen={inviteOpen} toggle={modalToggle} >
          <ModalHeader toggle={modalToggle}>{t('invite-user')}</ModalHeader>
          <ModalBody>
              <AnalysisInvitePatientForm setInviteOpen={setInviteOpen}/>
          </ModalBody>
        </Modal>

        <div>
          <Button id="btn-save" size="sm" className="btn-info pull-right">
            {t('btn-save')}
          </Button>

          <Button
            size="sm"
            id="btn-cancel"
            type="reset"
            className="btn-primary pull-right mr-3"
            onClick={(e) => {
              e.preventDefault();
              history.goBack();
            }}
          >
            {t('btn-cancel')}
          </Button>
        </div>
      </Form>
    </Fragment>
  );
};

export default AnalysisForm;
